import React from 'react';
import { Link } from 'react-router';
import { FaAngleRight, FaStepBackward, FaUserPlus, FaFileInvoiceDollar, FaClipboardCheck, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

class ItensMenu extends React.Component {
    constructor(props) {
        super(props);

        // Paleta baseada no seu novo padrão
        this.colors = {
            blueMega: '#809AE0',
            red: '#d10424',
            green: '#05860f',
            orange: '#f5aa00',
            gray: '#696969',
            bg: '#f8fafc'
        };
    }

    goBack() {
        window.history.back();
    }

    // Método renderCard padronizado
    renderCard(title, path, color, IconComponent) {
        const cardStyle = {
            display: 'flex',
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            marginBottom: '16px',
            height: '85px',
            alignItems: 'center',
            border: '1px solid #e2e8f0',
            textDecoration: 'none',
            color: 'inherit',
            overflow: 'hidden',
            cursor: 'pointer',
            transition: 'transform 0.2s ease'
        };

        const iconContainer = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '85px',
            height: '100%',
            backgroundColor: color,
            color: '#ffffff'
        };

        return (
            <Link to={path} style={{ textDecoration: 'none' }}>
                <div style={cardStyle} className="card-item-hover">
                    <div style={iconContainer}>
                        <IconComponent size={24} />
                    </div>
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', padding: '0 20px' }}>
                        <span style={{ fontSize: '15px', fontWeight: '600', color: '#334155', fontFamily: 'sans-serif' }}>
                            {title}
                        </span>
                        <FaAngleRight color="#cbd5e1" size={18} />
                    </div>
                </div>
            </Link>
        );
    }

    render() {
        const userType = localStorage.getItem('dental_y');

        return (
            <div style={{ padding: '40px 15px', backgroundColor: this.colors.bg, minHeight: '100vh' }}>
                <style>{`
                    .card-item-hover:hover {
                        background-color: #f1f5f9 !important;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
                    }
                `}</style>

                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    {/* Botão Voltar */}
                    <div 
                        onClick={this.goBack.bind(this)} 
                        style={{ cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontFamily: 'sans-serif', fontSize: '14px' }}
                    >
                        <FaStepBackward size={12} /> Voltar
                    </div>

                    <div style={{ 
                        textAlign: 'center', 
                        fontSize: '22px', 
                        fontWeight: 'bold', 
                        color: '#1e293b', 
                        marginBottom: '40px', 
                        fontFamily: 'sans-serif' 
                    }}>
                        PAINEL INCLUSÃO
                    </div>

                    {/* Lógica de Cards Baseada em Permissões */}
                    
                    {userType === 'SALESMAN' && (
                        this.renderCard('ADICIONAR DEPENDENTES', '/panel/inclusao', this.colors.blueMega, FaUserPlus)
                    )}

                    {(userType === 'SALESMAN' || userType === 'BROKER') && (
                        this.renderCard('PROPOSTAS AGUARDANDO PAGAMENTO', '/panel/lista-de-inclusoes?search=pendente', this.colors.red, FaFileInvoiceDollar)
                    )}

                    {this.renderCard('PROPOSTAS EM VALIDAÇÃO', '/panel/lista-de-inclusoes?search=em-validacao', this.colors.green, FaClipboardCheck)}

                    {this.renderCard('CONTRATOS IMPLANTADOS (60 DIAS)', '/panel/lista-de-inclusoes?search=ativo', this.colors.orange, FaCheckCircle)}

                    {this.renderCard('CONTRATOS CANCELADOS (60 DIAS)', '/panel/lista-de-inclusoes?search=cancelado', this.colors.gray, FaTimesCircle)}

                </div>
            </div>
        );
    }
}

export default ItensMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/Inclusao/ItensMenu.js
 **/